import React from "react";
import { FINANCIAL_PARTNERS } from "@/lib/content";

const FinancialPartners = () => {
  return (
    <section
      id="socios"
      data-testid="partners-section"
      className="relative bg-[#0B0410] text-[#F9F6F0] py-24 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#E6D5B8]" />
              <span
                className="text-[11px] tracking-luxury uppercase text-[#E6D5B8] font-medium"
                data-testid="partners-eyebrow"
              >
                Socios institucionales
              </span>
            </div>
            <h2
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08]"
              data-testid="partners-headline"
            >
              Productos financieros respaldados por instituciones{" "}
              <span className="italic text-[#E6D5B8]">de talla global</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base lg:text-lg text-[#F9F6F0]/70 font-light">
              Somos promotores autorizados Allianz México y mantenemos claves
              directas con Skandia y Dominion Capital Strategies — lo que
              significa acceso preferente, condiciones competitivas y
              acompañamiento real.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 border-y border-white/10">
          {FINANCIAL_PARTNERS.map((p, idx) => (
            <article
              key={p.name}
              data-testid={`partner-${idx}`}
              className={`p-10 lg:p-12 group hover:bg-[#150A1F] transition-colors duration-500 ${
                idx !== FINANCIAL_PARTNERS.length - 1
                  ? "md:border-r border-white/10"
                  : ""
              } ${idx !== 0 ? "border-t md:border-t-0 border-white/10" : ""}`}
            >
              <div className="h-14 mb-8 flex items-center">
                <span className="font-display text-3xl lg:text-4xl text-[#E6D5B8] tracking-tight">
                  {p.wordmark}
                </span>
              </div>
              <div className="text-[11px] tracking-luxury uppercase text-[#E6D5B8] mb-4">
                {p.relation}
              </div>
              <h3 className="font-display text-2xl lg:text-3xl font-light leading-tight text-[#F9F6F0]/85">
                {p.name}
              </h3>
              <p className="mt-6 text-sm lg:text-base text-[#F9F6F0]/65 leading-relaxed font-light">
                {p.detail}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinancialPartners;
